<template>
	<div class="radial-progress-bar">
		<div class="circle-wrapper" :style="circleWrapperStyles" aria-hidden="true">
			<div v-if="circleText" class="circle-text">
				<div class="heading-4">{{ circleText }}</div>
			</div>
			<svg
				v-if="offset >= 0"
				class="progress-ring"
				:width="size"
				:height="size"
			>
				<defs>
					<linearGradient
						:id="id"
						x1="60.7558406%"
						y1="39.6348003%"
						x2="29.0755488%"
						y2="87.9535115%"
					>
						<template v-if="barColor">
							<stop :stop-color="barColor"></stop>
						</template>
						<template v-else>
							<stop stop-color="#F8305D" offset="0%"></stop>
							<stop stop-color="#FBB38B" offset="100%"></stop>
						</template>
					</linearGradient>
				</defs>
				<circle
					ref="progressBar"
					class="progress-ring-circle"
					:stroke="`url(#${id})`"
					:stroke-width="strokeWidth"
					stroke-linecap="round"
					:stroke-dashoffset="offset"
					:stroke-dasharray="`${circumference} ${circumference}`"
					fill="transparent"
					:r="radius"
					:cx="size / 2"
					:cy="size / 2"
				/>
			</svg>

			<div
				class="icon-wrapper"
				:style="{
					height: `${size - strokeWidth}px`,
					width: `${size - strokeWidth}px`
				}"
			>
				<slot name="icon"></slot>
			</div>
		</div>
		<div class="bar-label" aria-hidden="true">
			<div class="body-text-2 title">
				{{ title }}
			</div>

			<div class="heading-4 status" aria-hidden="true">
				{{ status }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: Number,
			required: true
		},
		size: {
			type: Number,
			default: 60
		},
		title: {
			type: String,
			default: ''
		},
		status: {
			type: String,
			default: ''
		},
		barColor: {
			type: String,
			default: null
		},
		id: {
			type: String,
			default: 'grad1'
		},
		circleText: {
			type: [String, Number],
			default: ''
		}
	},
	data() {
		return {
			strokeWidth: 6,
			circleWrapperStyles: {
				height: `${this.size}px`,
				width: `${this.size}px`,
				backgroundColor: this.barColor ? this.barColor + '80' : 'default'
			}
		};
	},
	computed: {
		radius() {
			return this.size / 2 - this.strokeWidth / 2;
		},
		circumference() {
			return this.radius * 2 * Math.PI;
		},
		offset() {
			return this.circumference - (this.value / 100) * this.circumference;
		}
	}
};
</script>
<style lang="scss" scoped>
.radial-progress-bar {
	display: flex;
	align-items: center;

	.circle-wrapper {
		position: relative;
		border-radius: 100%;

		.progress-ring-circle {
			transform: rotate(-90deg);
			transform-origin: 50% 50%;
			position: absolute;
		}
		.circle-text {
			position: absolute;
			border-radius: 100%;
			height: 90%;
			width: 90%;
			top: 5%;
			left: 5%;
			display: inline-block;
			vertical-align: middle;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #f3f8ff;
		}

		.icon-wrapper {
			background-color: #f3f8ff;
			border-radius: 100%;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			z-index: -1;

			svg {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				margin: auto;
			}
		}
	}

	.bar-label {
		text-align: center;
		padding: 12px;

		.heading-4 {
			text-align: center;
			margin: 0;
			text-transform: capitalize;
		}
	}
}
</style>
